import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Grid,
  IconButton,
  Tooltip
} from "@mui/material";
import { BsEyeFill, BsPencilSquare, BsTrashFill } from "react-icons/bs";
import Swal from "sweetalert2";
import usericon from './user.png'
import './main.css'
export default function InfoCard2({ img_type, icon, type, data, onClick, keys, onAction = () => { } }) {
  const cols = type === "user" ? [2, 10] : [4, 8];
  const handleClick = onClick || (() => { });

  const avatar = (type, data, keys) => {
    const imageSrc = data[keys[0]];
    if (type === "user") {
      return (
        <Box
          component="img"
          src={usericon}
          loading="lazy"
          alt=""
          sx={{
            width: '100%',
            height: '100%',
            objectFit: "cover",
            borderRadius: 2,

          }}
        />
      );
    }
    return (
      <Box
        component="img"
        src={imageSrc}
        loading="lazy"
        alt=""
        onError={(e) => { e.target.style.display = 'none'; }}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: "cover",
          borderRadius: 2,
        }}
      />
    );
  };
  return (
    <Card
      className="shadow"
      sx={{
        // backgroundColor: "#ebebeb",
        borderRadius: 4,
        p: 2,
        cursor: "pointer",
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
      onClick={handleClick}
    >
      <Box color={'blue'} display={'flex'} gap={0.2} justifyContent={'end'}
        sx={{ position: 'absolute', right: 0, px: 2 }}>
        <IconButton onClick={() => onAction("More", data)} size="small">
          <BsEyeFill fontSize={12} />
        </IconButton>
        <IconButton onClick={() => onAction("Edit", data)} size="small">
          <BsPencilSquare fontSize={12} />
        </IconButton>
        <IconButton
          onClick={(e) => {
            e.stopPropagation(); // Prevent card click
            Swal.fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, delete it!"
            }).then((result) => {
              if (result.isConfirmed) {
                onAction("Delete", data);
              }
            });
          }}
          size="small"
        >
          <BsTrashFill fontSize={12} />
        </IconButton>
      </Box>
      <Box textAlign={'center'} sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Box
          // className="social-img-wrap"
          sx={{ aspectRatio: 1 / 1, height: 80, width: 80, display: 'inline-block', mx: 'auto' }}>
          {icon ? icon : avatar(type, data, keys)}
        </Box>
        {/* <Typography className="text" sx={{ fontSize: 14 }}>{data[keys[1]]}</Typography> */}
        {/* <Box className="social-img-wrap">
          <Box className="social-img">
            {icon ? icon : avatar(type, data, keys)}
          </Box>
        </Box> */}
        <Tooltip title={data[keys[1]]} arrow placement="top">
          <Typography
            className="text"
            sx={{
              //my: 0.5,
              fontSize: 18,
              fontWeight: 700,
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              display: "block",
              maxWidth: "100%"
            }}
          >
            {data[keys[1]]}
          </Typography>
        </Tooltip>
        {/* <Typography sx={{ my: 0.5 }} fontSize={16} className="text">{data[keys[1]]}</Typography> */}
        <Typography sx={{ my: 0.5 }} fontSize={11} className="text">{data[keys[3]]}</Typography>


        <Box display={'flex'} alignItems={'center'} gap={2} justifyContent={'center'} sx={{ mt: 'auto' }}>
          <Box>
            <Typography fontSize={20} className="text" fontWeight={700}>{data[keys[5]]}</Typography>
            <Typography fontSize={11} className="text">{keys[4]}</Typography>
          </Box>|
          <Box>
            <Typography fontSize={20} className="text" fontWeight={700}>{data[keys[7]]}</Typography>
            <Typography fontSize={11} className="text">{keys[6]}</Typography>
          </Box>|
          <Box>
            <Typography fontSize={20} className="text" fontWeight={700}>{data[keys[9]]}</Typography>
            <Typography fontSize={11} className="text">{keys[8]}</Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
